import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TelegramService {

  message: string = '';
  private telegramToken = '7511922874:AAF7F911tYxeOdsKCIm6ZzGZ6YaO6pluTeo'; // Замените на ваш токен
  private chatId = '-1002499398466'; // Замените на ваш chat_id

  constructor(private http: HttpClient) {}

  onSubmit(message: string) {
    const url = `https://api.telegram.org/bot${this.telegramToken}/sendMessage`;
    this.message = message;
    const payload = {
      chat_id: this.chatId,
      text: this.message,
      parse_mode: 'Markdown'
    };

    this.http.post(url, payload)
      .subscribe(
        response => {
          this.message = ''; // Очистить поле после отправки
        },
        error => {
          console.error('Error sending message:', error);
        }
      );
  }

}
